import * as React from 'react';
import images from 'react-payment-inputs/images';
import { Apply, Menu } from '../../../icons';

import { PaymentMethodViewProps } from './interface';
import { PaymentMethodMenu } from './payment-method-menu';
import { Styled } from './styled';


export const PaymentMethodTile: React.FC<PaymentMethodViewProps> = ({
  isBackup,
  isPrimary,
  isSubscription,
  onCardClick,
  menuItems,
  expiryString,
  cardType,
  cardLast4,
}) => {
  return (
    <Styled.PaymentMethodContainer
      isPrimary={isPrimary}
      isBackup={isBackup}
      isSubscription={isSubscription}
      onClick={onCardClick}
    >
      <Styled.PaymentMethodRow>
        <Styled.CardNumber>
          <span>••••</span>
          <span>••••</span>
          <span>••••</span>
          <span>{cardLast4}</span>
        </Styled.CardNumber>
      </Styled.PaymentMethodRow>
      <Styled.CardStatus>
        {isPrimary ? 'Primary' : isBackup ? 'Backup' : ''}
        {isSubscription ? <Apply /> : null}
      </Styled.CardStatus>
      <Styled.PaymentMethodRow>
        <Styled.ExpiredDate>{expiryString}</Styled.ExpiredDate>
        <Styled.CardType
          xmlns="http://www.w3.org/2000/svg"
          height='30'
          viewBox='0 0 24 16'
        >
          {images[cardType]}
        </Styled.CardType>
        <PaymentMethodMenu menuItems={menuItems} icon={Menu} />
      </Styled.PaymentMethodRow>
    </Styled.PaymentMethodContainer>
  );
};
